import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Select, format, Avatar,  Empty, Popconfirm,  PlusOutlined,  Input, EditOutlined, Button, DeleteFilled, SearchOutlined, useDispatch, useSelector,  message,Tooltip, Progress } from '../AntComponent';
import { deleteProject,  getProjectList,getProjDetail, } from '../../store/actions/project-management/ProjectAction';
import { useForm } from 'antd/lib/form/Form';
import { getProjectType } from '../../store/actions/project-management/ProjectSettingAction';
import ProjectDetail from './ProjectDetail';
import AddProject from './modal/AddProject';
export default function ProjectList() {
  const [form] = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { typeList } = useSelector(state => state.projectSetting);
  const { profileInfo } = useSelector(state => state.userPrf);
  const { prjListData, prjInfo, success2, success8, loading } = useSelector(state => state.project);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const yearID = profileInfo?.data?.year[0]?.yearID;
  const appUserID = profileInfo?.data?.appUser?.appuserID;
  const locationID = profileInfo?.data?.location[0]?.locationID;
  const isManager = profileInfo?.data?.role?.isManager;
  const roleCategory = profileInfo?.data?.role?.roleCategory;
  const managerName = profileInfo?.data?.appUser?.userName;
  const mngID = profileInfo?.data?.employeeDetail[0]?.empID;
  const [projectID, setProjectID] = useState(0);
  const [projectNo, setProjectNo] = useState(0);
  const [prjStatus, setPrjStatus] = useState("Active");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [tblSearchData, setTblSearchData] = useState("");
  const data = prjListData?.data?.objProjectList || [];
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const data1 = typeList ? typeList?.data : [];
  const dateformat = profileInfo?.data?.settings ? profileInfo?.data?.settings[0]?.dateFormat : "DD-MM-YYYY";
  const [showDetail, setShowDetail] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const successmsg = showSuccessMsg ? success2 : null;
  const [showDelMsg, setShowDelMsg] = useState(false);
  const successDelmsg = showDelMsg ? success8 : null;
  const [searchTableVal, setsearchTableval] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const totalPage = prjListData?.data?.serverSearchables?.recordsTotal || 0;
  const [isHovered, setIsHovered] = useState(false);
  const avatarColors = ["#1C3F6E", "#FFA034", "#80C271", "#2E67A0"];
  const twoColors = { '0%': '#108ee9', '100%': '#87d068' };
  const [addProject, setAddProject] = useState(false)
  const customLocale = {
    emptyText: <Empty className='p-2' description={prjStatus == "Active" ? "No Active Projects Available" :
      prjStatus == "Hold" ? "No Holded Projects Available" : prjStatus == "Cancel" ? "No Cancelled Projects Available" :
        prjStatus == "Complete" ? "No Completed Projects Available" : prjStatus == "Archived" ? "No Archived Projects Available" : "No Projects Available"} />
  }

  const prjStatusOptions = [
    {
      value: 'Active',
      label: 'Active',
    },
    {
      value: 'Hold',
      label: 'On Hold',
    },
    {
      value: 'Cancel',
      label: 'Cancel',
    },
    {
      value: 'Complete',
      label: 'Complete',
    },
    {
      value: 'Archived',
      label: 'Archived',
    },
  ];

  const columns = [
    {
      title: 'Project Type',
      dataIndex: 'initiativeType',
      key: 'initiativeType',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Project Code',
      dataIndex: 'projectNo',
      key: 'projectNo',
    },
    {
      title: 'Project Name',
      dataIndex: 'projectName',
      key: 'projectName',
    },
    {
      title: 'PM/DM',
      dataIndex: 'pm',
      key: 'pm',
      render: (pm, record) => {
        return (
          <div>
            {record.managerList?.length > 0 ?
              <div>
                {record.managerList?.map((m, i) => {
                  return <span key={m.managerID}><Avatar style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>{m.managerName.substring(0, 1)}</Avatar></span>
                })}
              </div>
              : ""}
          </div>
        )
      }
    },
    {
      title: 'Team',
      key: 'teamList',
      dataIndex: 'teamList',
    //   render: (teamList, record) => {
    //     return (
    //       // <div>
    //       //   {record.teamList?.length > 0 ?
    //       //     <div>
    //       //       {record.teamList?.map((m, i) => {
    //       //         return <span key={m.empID}><Avatar style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>{m.firstName.substring(0, 1)}</Avatar></span>
    //       //       })}
    //       //     </div>
    //       //     : ""}
    //       // </div>
    //     )
    //   },
    // },
    
      render: (teamList, record) => (
        <div
          onMouseEnter={() => setIsHovered((prevState) => ({ ...prevState, [record.projectID]: true }))}
          onMouseLeave={() => setIsHovered((prevState) => ({ ...prevState, [record.projectID]: false }))}
        >
          {record.teamList?.length > 0 ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {record.teamList.slice(0, 5).map((m, i) => (
                <span key={m.empID}>
                  {!isHovered[record.projectID] && (
                    <Avatar style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>
                      {m.firstName.substring(0, 1)}
                    </Avatar>
                  )}
                </span>
              ))}
              {record.teamList.length > 5 && !isHovered[record.projectID] && (
                <span>
                  <Avatar style={{ backgroundColor: '#ccc' }}>
                    <PlusOutlined />
                  </Avatar>
                </span>
              )}
              {isHovered[record.projectID] && (
                <div style={{ display: 'flex' }}>
                  {record.teamList.map((m, i) => (
                    <span key={m.empID}>
                      <Avatar style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>
                        {m.firstName.substring(0, 1)}
                      </Avatar>
                    </span>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      title: 'Start Date',
      dataIndex: 'estStartDate',
      key: 'estStartDate',
      render: (estStartDate) => {
        return prjListData ? format(new Date(estStartDate), dateformat) : null
      }
    },
    {
      title: 'End Date',
      dataIndex: 'estEndDate',
      key: 'estEndDate',
      render: (estEndDate) => {
        return prjListData ? format(new Date(estEndDate), dateformat) : null
      }
    },
    {
      title: 'Progress',
      dataIndex: 'progress',
      key: 'progress',
    },
    {
      title: 'Status',
      dataIndex: 'projStatus',
      key: 'projStatus',
    },
    {
      title: 'Action',
      key: 'action',
      render: (id, record) => (
        <div size="middle">
          <Tooltip title="Edit Project" className='mt-0'>
            <EditOutlined onClick={() => { editProject(record.projectID); setShowDetail(true); setRowData(record); setProjectID(record.projectID); setProjectNo(record.projectNo) }} />
          </Tooltip>
            <Popconfirm
              description="Are you sure to delete this project?"
              onConfirm={() => deleteProj(record.projectID)}
              okText="Yes"
              cancelText="No"
            >
              <span><Tooltip title="Delete Project" className='mt-0'> <DeleteFilled className="text-danger ms-1" /></Tooltip></span>
            </Popconfirm>
        </div>
      ),
    },
  ];

  const deleteProj = (pid) => {
    let id = `${tenantID}/${pid}`
    dispatch(deleteProject(id));
    setShowDelMsg(true);
  }

  useEffect(() => {
    if (successDelmsg) {
      message.success("Project deleted successfully");
      getprjLists(tblSearchData, pageIndex, pageSize, sortField, sortOrder, prjStatus);
      setShowDelMsg(false);
    }
  }, [successDelmsg]);

  const handleOpenDrawer = () => {
    setShowDetail(true)
    setAddProject(true)
    // setOpenDrawer(true);
    setProjectID(0)
  }
  useEffect(() => {
    if (tenantID) {
        let ids = `${tenantID}/${locationID}/${projectID}`;
        dispatch(getProjDetail(ids));
    }
}, [showDetail == true]);

  function getprjLists(search, page, pageSize, sortField, sortOrder, status) {
    let inputJson = {
      "objProjectListInput":
      {
        "TenantID": tenantID,
        "LocationID": locationID,
        "ManagerID": roleCategory == "Management" ? 0 : isManager ? mngID : 0,
        "ProjStatus": status
      },
      "serverSearchables": {
        "search_data": search,
        "page_No": page,
        "page_Size": pageSize,
        "orderBy_Column": sortField,
        "order_By": sortOrder
      },
      "objProjectList": []
    }

    dispatch(getProjectList(inputJson));

  }
  useEffect(() => {
    if (tenantID) {
      getprjLists(tblSearchData, pageIndex, pageSize, sortField, sortOrder, prjStatus);
    }
  }, [tenantID]);


  function getProjectTypeList() {
    if (tenantID) {
      let ids = `${tenantID}/${locationID}/0`;
      dispatch(getProjectType(ids));
    }
  }
  useEffect(() => {
    getProjectTypeList();
  }, [dispatch, tenantID]);

  useEffect(() => {
    if (successmsg) {
      if(prjInfo?.data?.msg === "Already Exists"){
        message.error("Can't be created, Project Already Exists ")
      }
      else{
        message.success("Project Created Successfully");
        getProjectTypeList();
        setShowDetail(false)
      }
      setOpenDrawer(false);
      setShowSuccessMsg(false);
      getprjLists(tblSearchData, pageIndex, pageSize, sortField, sortOrder, prjStatus);
      form.resetFields();
    }
  }, [successmsg]);

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setsearchTableval(e.target.value);
      setPageIndex(1);
      getprjLists(e.target.value, 1, pageSize, null, null, prjStatus);
    }
  }
  const resetSearch = (e) => {
    if (e.key === "Backspace" && !e.target.value) {
      setsearchTableval("");
      setPageIndex(1);
      getprjLists(e.target.value, 1, pageSize, null, null, prjStatus);
    }
  }
  const editProject = (id) => {

  }

  const addCallbackFunc = (item, item1) => {
    setOpenDrawer(item);
    setShowSuccessMsg(item1);
  }
  
  const handleChange = (e) => {
    setPageIndex(1);
    setPrjStatus(e);
    getprjLists(tblSearchData, 1, pageSize, null, null, e);
  }

  const tableChange = (pagination, ...sorted) => {
    let sort = "";
    if (sorted[1].order == "ascend") {
      sort = "asc";
    } else sort = "desc";
    setSortField(sorted[1].field);
    setSortOrder(sort);
    setPageIndex(pagination.current);
    getprjLists(searchTableVal, pagination.current, pagination.pageSize, sorted[1].field, sort, prjStatus);
  }
  const refreshTable = () =>{
    setTblSearchData("");
    setPageIndex(1);
    getprjLists(tblSearchData, 1, pageSize, null, null, prjStatus);
  }
  const callbackFunc = (item,item1) => {
    setShowDetail(item);
    setAddProject(item1)
    refreshTable()
  }

  return (<>
    {!showDetail ?
      <div className='mb-3 rounded d-flex'>
        <h5 className='col-auto'>Project List</h5>
      </div> : ""
    }
    {!showDetail ?
      <div className='bg-white  rounded h-100 prj-list-cont'>
        <div className='row text-end mb-2 p-3'>
          <div className='col-auto ms-auto d-flex'>
            <Input placeholder="Search Project" prefix={<SearchOutlined />}
              onKeyDown={(e) => handleSearch(e)}
              onKeyUp={(e) => resetSearch(e)} />
            <Select
              defaultValue={prjStatus}
              className='col-md-4 text-start mx-2'
              onChange={handleChange}
              options={prjStatusOptions}
            />
            <Tooltip title="Add Project" className='mt-0'>
              <Button type="primary" className='px-1 py-0 tbl-btn' icon={<PlusOutlined />} onClick={handleOpenDrawer}>Add</Button>
            </Tooltip>
          </div>

        </div>
        <Table className="entitlement-table" rowKey="projectID" columns={columns} dataSource={data} loading={loading} locale={customLocale}
          onChange={tableChange}
          pagination={{
            current: pageIndex,
            pageSize: pageSize,
            total: totalPage,
            onChange: (page, pageSize) => {
              setPageIndex(page);
              setPageSize(pageSize);
              getprjLists(searchTableVal, page, pageSize, sortField, sortOrder, prjStatus);
            }
          }} />
      </div>
      :
      <ProjectDetail data={{ rowData: rowData, projectID: projectID,projectNo:projectNo, tenantID: tenantID, locationID: locationID, appUserID: appUserID, dateformat: dateformat, callbackFunc: callbackFunc , addProject: addProject}} />}
    {openDrawer && <AddProject data={{ projectID: projectID, dateformat: dateformat, rowData: null, addCallbackFunc: addCallbackFunc, openDrawer: openDrawer }} />}

  </>
  )
}